import firebase from 'firebase/app';
import 'firebase/firestore';
import store from '@/store';
import Utils from '@/libs/Utils';
import FireBaseUtils from '@/libs/FirebaseUtils';
import { FormModel } from '@/models/FormModel';

export default class FormApi {
  /**
   * @description upload form document in vuex store to firestore
   *
   * @param isSubmitted
   * @param signature identify who filled this form (for management purpose)
   */
  static async save(isSubmitted = false, signature = ''): Promise<void> {
    const db = firebase.firestore();
    const user = FireBaseUtils.safeGetUser();
    const { form } = store.state;

    if (!form.streamId) {
      // generate new stream id if current form not specified one
      form.streamId = await this.getStreamId();
    }

    form.submitTime = new Date().toISOString();

    form.signature = signature;

    form.formId = user.uid;

    form.isSubmitted = isSubmitted;

    const formContent = Utils.toObject(form);

    await db.collection('forms').doc(form.formId).set(formContent);
  }

  /**
   * @description get form document from firestore for current login user, then load the document into vuex store
   *
   * the result object obtained by get() is DocumentSnapshot
   * (@see https://firebase.google.com/docs/reference/js/firebase.firestore.DocumentSnapshot?authuser=0)
   */
  static async load(): Promise<void> {
    const db = firebase.firestore();
    const user = FireBaseUtils.safeGetUser();

    const formId = user.uid;
    const docSnp = await db.collection('forms').doc(formId).get();
    const doc = docSnp.data() as FormModel;

    if (doc) {
      store.commit('updateForm', doc);
    }
  }

  static async getStreamId(): Promise<number> {
    const db = firebase.firestore();
    const formVarRef = db.collection('variables').doc('form');

    const streamId = await db.runTransaction(async (t) => {
      const doc = await t.get(formVarRef);
      const data = doc.data();
      if (!data) {
        throw new Error('variables.form not found');
      }
      const newStreamCounter = data.streamCounter + 1;
      await t.update(formVarRef, { streamCounter: newStreamCounter });
      return newStreamCounter;
    });
    return streamId;
  }
}
